<template>
  <div>
    <Modal title="Add A Schedule" :open.sync="showScheduleModal">
      <div class="p-6">
        <schedule-form mode="create" @success="scheduleCreated" />
      </div>
    </Modal>

    <div class="p-6 text-center text-gray-500 border rounded bg-gray-50" v-if="schedules.meta.total < 1">
      <div>You have no schedules.</div>
      <button type="button" @click="showScheduleModal = true" class="mt-4 btn btn-secondary btn-sm">
        Create Schedule
      </button>
    </div>
    <div v-else>
      <div class="p-1 overflow-x-visible overflow-y-auto border rounded h-36">
        <label class="flex items-center px-1 py-2 border-0 cursor-pointer" v-for="schedule in schedules.data" :key="schedule.id">
          <toggle 
            :value="isInArray(schedule.id)" 
            :name="schedule.id.toString()" 
            @change="toggleSchedule(schedule)"
            class="mb-0 mr-3" />
            <div class="flex items-center mr-3">
              {{ schedule.start_time.substring(0, 5) }} - {{ schedule.end_time.substring(0, 5) }}
            </div>
            <div class="flex space-x-1 text-xs font-bold text-center">
              <div v-html="`M`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.monday }"></div>
              <div v-html="`T`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.tuesday }"></div>
              <div v-html="`W`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.wednesday }"></div>
              <div v-html="`T`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.thursday }"></div>
              <div v-html="`F`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.friday }"></div>
              <div v-html="`S`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.saturday }"></div>
              <div v-html="`S`" class="flex items-center justify-center w-10 h-5 bg-gray-100 rounded" :class="{ 'opacity-25': !schedule.sunday }"></div>
            </div>
        </label>
      </div>
      <button type="button" @click="showScheduleModal = true" class="mt-3 btn btn-secondary btn-sm">
        Add A Schedule
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ScheduleForm from '@/components/ScheduleForm'

  export default {
    name: 'ScheduleToggle',

    components: {
      ScheduleForm
    },

    created () {
      this.getSchedules()
      this.$store.subscribeAction((action, state) => {
        if (action.type === 'publishEvent' && action.payload === 'updateSchedules') {
          this.getSchedules()
        }
      })
    },

    props: {
      parent: {
        type: Object
      },

      type: {
        type: String
      }
    },

    computed: {
      ...mapState(['event']),

      options () {
        return this.schedules.map(schedule => schedule.id)
      }
    },

    data () {
      return {
        loading: true,
        schedules: {
          meta: {},
          data: []
        },
        showScheduleModal: false
      }
    },

    methods: {
      getSchedule (id) {
        return this.schedules.filter((schedule) => { return schedule.id === id })[0]
      },

      isInArray (id) {
        return this.parent.schedules.some(schedule => schedule.id === id)
      },

      toggleSchedule (schedule) {
        this.$emit('toggle', schedule)
      },

      async getSchedules () {
        try {
          const { data } = await this.$api.get(`account/${this.$route.params.account}/schedules`)
          this.schedules = data.schedules
          this.loading = false
        } catch (error) {
          console.error(error)
        }
      },

      scheduleCreated () {
        this.$store.dispatch('publishEvent', 'updateSchedules')
        this.showScheduleModal = false
      }
    }
  }
</script>